import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import BreadCrumbsComponent from "./breadcrumbs";
import CustomContainer from "./container";

const CustomHeader = ({ title, breadcrumbData }) => {
  return (
    <Box
      sx={{
        background: "rgba(211, 211, 211,0.2)",
      }}
      mb={3}
    >
      <CustomContainer>
        <Box py={0.8}>
          <Grid container spacing={2} alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={4}>
              <Typography
                color="text.primary"
                variant="h3"
                fontWeight={700}
                textTransform="capitalize"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </Grid>
            <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
              <BreadCrumbsComponent data={breadcrumbData} />
            </Grid>
            <Grid 
              item 
              xs={12} 
              md={4} 
              sx={{ 
                display: { xs: "none", md: "block" },
                textAlign: "right"
              }}
            >
              <Typography
                color="primary"
                variant="h3"
                fontWeight={800}
                textTransform="capitalize"
              >
                Manchester Economic Forecasting
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default CustomHeader;
